exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container {\n  line-height: 2;\n}\n", ""]);
